import { render, staticRenderFns } from "./AreaUmidaEua.vue?vue&type=template&id=ac6733cc&lang=pug"
import script from "./AreaUmidaEua.vue?vue&type=script&lang=js"
export * from "./AreaUmidaEua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports